// reducer.js
import { GET_ALL_USERS_SUCCESS,GET_ALL_USERS_ERROR, CREATE_USER_SUCCESS, CREATE_USER_ERROR, EDIT_USER_SUCCESS, EDIT_USER_ERROR, CHANGE_USER_STATUS_SUCCESS, CHANGE_USER_STATUS_ERROR, DELETE_USER_SUCCESS, DELETE_USER_ERROR } from '../actionTypes';

export const usersInitialState = {
  data: null,
  error: null,
  users: null,
  message: null
};

export default (state = usersInitialState, action) => {
  switch (action.type) {
    case GET_ALL_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload,
        error: null,
      };
    case GET_ALL_USERS_ERROR:
      return {
        ...state,
        users: null,
        error: action.payload,
      };
      case CREATE_USER_SUCCESS:
      return {
        ...state,
        message: action.payload,
        error: null,
      };
    case CREATE_USER_ERROR:
      return {
        ...state,
        message: null,
        error: action.payload,
      };
      case EDIT_USER_SUCCESS:
      return {
        ...state,
        message: action.payload,
        error: null,
      };
    case EDIT_USER_ERROR:
      return {
        ...state,
        message: null,
        error: action.payload,
      };
    case CHANGE_USER_STATUS_SUCCESS:
      return {
        ...state,
        message: action.payload,
        error: null,
      };
    case CHANGE_USER_STATUS_ERROR:
      return {
        ...state,
        message: null,
        error: action.payload,
      };
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        message: action.payload,
        error: null,
      };
    case DELETE_USER_ERROR:
      return {
        ...state,
        message: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

